import script from "./MozambiquePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MozambiquePage.vue?vue&type=script&setup=true&lang=js"

import "./MozambiquePage.vue?vue&type=style&index=0&id=db380910&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db380910"]])

export default __exports__